import { useState, useEffect } from 'react';
import io from 'socket.io-client';
import { BACKEND_URL } from '../utils';

export function useSocket() {
  const [socket, setSocket] = useState(null);
  const [playerId, setPlayerId] = useState('');

  useEffect(() => {
    const socketOptions = {
      transports: ['websocket', 'polling'],
      upgrade: true,
      rememberUpgrade: true,
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      reconnectionAttempts: 5,
      timeout: 20000,
      path: '/socket.io/'
    };

    const newSocket = BACKEND_URL ? io(BACKEND_URL, socketOptions) : io(socketOptions);
    setSocket(newSocket);

    newSocket.on('connected', (data) => {
      console.log('Connected to server:', data.session_id);
      setPlayerId(data.session_id);
    });

    return () => newSocket.close();
  }, []);

  return { socket, playerId };
}
